import Registry from "../Utils/Registry";


export default class AbstractModel{
    constructor(){
        this.api = AbstractModel.getApi();
        this.id = null;
    }

    isLoaded(){
        return this.id !== null && this.id !== "";
    }

    setData(data={}){
        for(let k in this){
            if(data.hasOwnProperty(k))
                this[k] = data[k];
        }
    }

    static getApi(){
        return Registry.registered("api");
    }
}


// WEBPACK FOOTER //
// ./src/models/abstract.js